
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/ridgeblade",
      function () {
        return require("private-next-pages/brands/ridgeblade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/ridgeblade"])
      });
    }
  